import { render, staticRenderFns } from "./DonorSearchResults.vue?vue&type=template&id=20a44412&scoped=true&"
import script from "./DonorSearchResults.vue?vue&type=script&lang=js&"
export * from "./DonorSearchResults.vue?vue&type=script&lang=js&"
import style0 from "./DonorSearchResults.vue?vue&type=style&index=0&id=20a44412&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a44412",
  null
  
)

export default component.exports